// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yWFaSDRsdc1vaUzHLWnn{color:var(--light-blue-60)}.xW6CFCgofHQSTMhx8J5Z{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectAllButton": `yWFaSDRsdc1vaUzHLWnn`,
	"text": `xW6CFCgofHQSTMhx8J5Z`
};
export default ___CSS_LOADER_EXPORT___;
